import React from 'react';
import { Icon, notification } from '@ss/mtd-react';
import { Upload as BlockUpload } from '@block/plug';
import './index.scss';

const { helper } = BlockUpload;

interface Props extends DefaultToFormItem {
  url?: any;
  fileType?: string;
  size?: number;
  onChange?: (file?: any) => void;
}

interface State {
  loading?: boolean;
  value?: string;
}

class Upload extends React.Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
    };
  }

  handleValidateFileType = (file, accepted) => {
    const fileExt = (/^.*\.(.*)$/.exec(file.name) || ['', ''])[1].toLowerCase();
    const valid = accepted.includes(fileExt);
    if (!valid) {
      notification.error({
        message: `不支持上传非 ${accepted.join('、')}格式文件，请重新上传`,
      });
    }
    return valid;
  };

  handleValidateFileSize = (file, size) => {
    const valid = file.size / 1024 <= size * 1024;
    if (!valid) {
      notification.error({
        message: `文件大小超过${size}M,请重新上传`,
      });
    }
    return valid;
  };

  handleUpload = (file) => {
    const { url, fileType, size } = this.props;
    const type = fileType || ['png', 'jpeg', 'jpg', 'bmp'];
    const photoSize = size || 20;
    this.setState({
      loading: true,
    });
    if (!this.handleValidateFileType(file, type) || !this.handleValidateFileSize(file, photoSize)) {
      this.setState({
        loading: false,
      });
      return false;
    }

    helper.upload(url, file, {
      params: {},
      onSuccess: (res) => {
        const { onChange } = this.props;
        onChange?.(res || {});
        this.setState({
          loading: false,
        });
      },
      onError: (err) => {
        this.setState({
          loading: false,
        });
        notification.error({
          message: err.message || '上传失败',
        });
      },
    });
    return null;
  };

  render() {
    const { loading } = this.state;
    return (
      <BlockUpload
        //
        className="add-btn"
        multiple={false}
        disabled={loading}
        onUpload={this.handleUpload}
      >
        <Icon type="add" />
        {loading ? '上传中' : '补充材料'}
      </BlockUpload>
    );
  }
}

export default Upload;
